import { createSlice } from '@reduxjs/toolkit';
import { getAllTestimonials } from '../api/testimonial';

export const testimonialSlice = createSlice({
  name: 'testimonial',
  initialState: {
    loading: false,
    error: {},
    testimonials: {},
  },
  reducers: {
    clearTestimonialError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getAllTestimonials.pending]: (state) => {
      state.loading = true;
    },
    [getAllTestimonials.fulfilled]: (state, action) => {
      state.loading = false;
      state.testimonials = action.payload;
      state.error = {};
    },
    [getAllTestimonials.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearTestimonialError } = testimonialSlice.actions;

export default testimonialSlice.reducer;
